import React, { FC } from "react";

export const MaterialIcon: FC<{ icon: string; className?: string }> = ({
  className,
  icon,
}) => {
  return <span className={"material-icons " + className}>{icon}</span>;
};
